module.exports = __webpack_public_path__ + "static/media/MY.2efa85b6.svg";